import { DEFAULT_MANIFEST } from "./constants";

export function setupMeta(api /*baseUrl*/) {
  document.title = api.title;

  document
    .querySelector('meta[name="theme-color"]')
    .setAttribute(
      "content",
      api.manifest.theme_color ||
        api.themeConf?.primary ||
        DEFAULT_MANIFEST.theme_color
    );

  if (api.manifest.favicon) {
    document
      .querySelector('link[rel="shortcut icon"]')
      .setAttribute(
        "href",
        api.manifest.favicon.includes("://")
          ? api.manifest.favicon
          : `${window.location.origin}/static/tenants/${api.tenant}/${api.manifest.favicon}`
      );
  }

  /*document.getElementById("manifest").setAttribute(
    "href",
    URL.createObjectURL(
      new Blob(
        [
          JSON.stringify({
            ...DEFAULT_MANIFEST,
            ...api.manifest,
            icons:
              api.manifest.icons?.map((i) => ({
                ...i,
                src: i.src.includes("://")
                  ? i.src
                  : `${window.location.origin}${api.tenantStaticUrl}${i.src}`,
              })) ||
              DEFAULT_MANIFEST.icons.map((i) => ({
                ...i,
                src: i.src.includes("://")
                  ? i.src
                  : `${window.location.origin}${i.src}`,
              })),
            name: api.title,
            scope: baseUrl,
            start_url: `${baseUrl}?source=pwa`,
            theme_color:
              api.manifest.theme_color ||
              api.themeConf?.primary ||
              DEFAULT_MANIFEST.theme_color,
          }),
        ],
        { type: "application/json" }
      )
    )
  );*/
}
